import { http } from '../../services/http';
import axios from 'axios';

function allSelectPagesVisited(state) {
  return (
    state.pages[0].visited &&
    state.pages[1].visited &&
    state.pages[2].visited &&
    state.pages[3].visited
  );
}

function initialState() {
  return {
    roofAngle: 'slanted', //flat, slanted
    roofType: null,
    numberOfSolarPannels: null,
    solarPanelType: null,
    panelType: null,
    panelsVal: {
      kwtAar: 0,
    },
    CustomerType: { id: 1, name: 'Privat', value: 'privat' },
    CustomerInformation: {
      fullName: '',
      phoneNumber: '',
      email: '',
      address: {},
      postalCode: '',
      postalArea: '',
      birthdate: '',
      comment: '',
      agreedToTerms: false,
      agreedToMarketing: false,
      location: {},
    },
    CustomerInformationValid: false,
    discountCodeUserInput: '',
    discountCode: 'haugalandsol-UTGÅTT',
    discount: 0,
    roof: null,
    coordinates: {
      lat: 0.0,
      lng: 0.0,
    },
    coordinatesTriggerNavigation: false,
    offer: {},
    offers: {},
    isLoading: false,
    isLoadingBestRoof: false,
    loadingText: '',
    imagePath:
      process.env.NODE_ENV === 'production'
        ? 'https://static.hkraft.no/soltak'
        : '', // relative image paths won't work when component is loaded remotely
    showIntro: true,
    currentPageIndex: 0,
    selectedAddress: null,
    isOfferSubmitted: false,
    errorMessage: '',
    pages: [
      { name: 'Tak', visited: true },
      { name: 'Kundetype', visited: false },
      { name: 'Taktype', visited: false },
      { name: 'Paneler', visited: false },
      { name: 'Kontakt', visited: false },
      { name: 'Oppsummering', visited: false },
    ],
    elPriceKWh: 1.06625,
    avgAnnualConsumption: 20000,
    isAutoSelectedRoof: false,
  };
}

const state = initialState();

const mutations = {
  setIsLoading(state, payload) {
    state.isLoading = payload;
  },
  setLoadingText(state, payload) {
    state.loadingText = payload;
  },
  setCustomerInformation(state, payload) {
    state.CustomerInformation = {
      ...state.CustomerInformation,
      ...payload.CustomerInformation,
    };
  },
  setCustomerType(state, payload) {
    state.CustomerType = payload;

    if (allSelectPagesVisited(state)) {
      state.offers = {};
      this.dispatch('updateOffer');
    }
  },
  setCustomerInformationValid(state, payload) {
    state.CustomerInformationValid = payload;
  },
  setDiscountCodeUserInput(state, payload) {
    state.discountCodeUserInput = payload;
  },
  setDiscount(state, payload) {
    state.discount = payload;
  },
  setOffer(state, payload) {
    if (
      new Date() >= new Date(2020, 5, 2) &&
      new Date() <= new Date(2020, 5, 15)
    ) {
      payload.offer.paneler.map((panel) => {
        // fjern HKs 10% påslag fra prisen eks. mva. -> SCSs kampanjepris eks. mva.
        const scsDiscountedPrice_ex_mva = panel.pris_ex_mva / 1.1;
        // fjern SCSs 10% rabatt fra prisen eks. mva. -> SCSs ordinære pris eks. mva.
        const scsFullPrice_ex_mva = scsDiscountedPrice_ex_mva / 0.9;
        // legg på HKs 20% påslag (før kampanjen) på prisen eks. mva. -> HKs ordinære pris inkl. mva.
        const hkFullPrice_ex_mva = scsFullPrice_ex_mva * 1.2;
        // legg på 25% mva. på prisen eks. mva. -> HKs ordinære pris inkl. mva.
        const hkFullPrice = hkFullPrice_ex_mva * 1.25;
        panel['fullPrice'] = hkFullPrice;
      });
    }

    state.offer = payload.offer;

    if (state.offers['roofTypeId_' + state.roofType.id]) {
      state.offers['roofTypeId_' + state.roofType.id][
        'panelTypeId_' + state.solarPanelType.id
      ] = payload.offer;
    } else {
      state.offers['roofTypeId_' + state.roofType.id] = {
        ['panelTypeId_' + state.solarPanelType.id]: payload.offer,
      };
    }
  },
  setPanelsVal(state, payload) {
    state.panelsVal = payload.panelsVal;
  },
  setRoofType(state, payload) {
    state.roofType = payload.roofType;
  },
  setNumberOfSolarPannels(state, payload) {
    state.numberOfSolarPannels = payload;
  },
  setSolarPanelType(state, payload) {
    state.solarPanelType = payload.solarPanelType;
    if (state.roof) {
      this.dispatch('updateOffer');
    }
  },
  setRoofAngle(state, payload) {
    state.roofAngle = payload.roofAngle;
  },
  setCoordinates(state, payload) {
    state.coordinates = payload.coordinates;
    //  If address is set, we add it to the Customers payment address.
    if (payload.coordinates && payload.coordinates.address) {
      state.CustomerInformation.location = payload.coordinates.address;
      state.CustomerInformation.postalCode =
        payload.coordinates.address.PostNummer;
      if (payload.coordinates.address.PostSted) {
        state.CustomerInformation.postalArea =
          payload.coordinates.address.PostSted.charAt(0).toUpperCase() +
          payload.coordinates.address.PostSted.substring(1).toLowerCase();
      }
      state.CustomerInformation.address = `${payload.coordinates.address.GateNavn} ${payload.coordinates.address.AdresseHusNummer}`;
    }

    if (allSelectPagesVisited(state)) {
      state.offers = {};
      this.dispatch('updateOffer');
    }
  },
  setCoordinatesTriggerNavigation(state, payload) {
    state.coordinatesTriggerNavigation = payload;
  },
  roofSelected(state, payload) {
    state.roof = payload.roof;

    state.offers = {};
  },
  setShowIntro(state, payload) {
    state.showIntro = payload;
  },
  setCurrentPageIndex(state, payload) {
    state.currentPageIndex = payload;

    state.pages[payload].visited = true;
  },
  setIsOfferSubmitted(state, payload) {
    state.isOfferSubmitted = payload;
  },
  setErrorMessage(state, payload) {
    state.errorMessage = payload;
  },
  setSelectedAddress(state, payload) {
    state.selectedAddress = payload;
  },
  setPhoneNumber(state, payload) {
    state.CustomerInformation.phoneNumber = payload;
  },
  setIsAutoSelectedRoof(state, payload) {
    state.isAutoSelectedRoof = payload;
  },
  setOffers(state, payload) {
    state.offers = payload;
  },
  setIsLoadingBestRoof(state, payload) {
    state.isLoadingBestRoof = payload;
  },
  resetOfferSubmission(state) {
    state.isOfferSubmitted = initialState().isOfferSubmitted;
    state.currentPageIndex = initialState().currentPageIndex;
  },
};

const actions = {
  getOfferFromBackend(state) {
    if (
      state.state.coordinates.lat === 0 &&
      state.state.coordinates.lng === 0
    ) {
      return;
    }
    const data = {
      roof: state.state.roof,
      roofType: state.state.roofType,
      solarPanelType: state.state.solarPanelType,
      coordinates: state.state.coordinates,
      customerType: state.state.CustomerType.value,
    };

    state.commit('setIsLoading', true);

    return http
      .post('solkart-offer', data)
      .then(function (response) {
        state.commit('setOffer', {
          offer: response.data,
        });
        state.commit('setSelectedAddress', response.data.adresse);
        state.commit('setIsLoading', false);

        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  },

  submitOffer({ state }) {
    // Dont wait for newsletter signup. This can just run in the background
    if (
      state.CustomerInformation.agreedToMarketing &&
      state.CustomerInformation.email
    ) {
      axios
        .post('https://hkraft.no/wp-json/hkraft/newsletter/subscribe', {
          email: state.CustomerInformation.email,
        })
        .then(function () {})
        .catch(function () {});
    }

    const payload = {
      ...state,
      CustomerType: state.CustomerType.value,
    };

    return http
      .post('solkart-submit', payload)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return Promise.reject(error.response);
      });
  },

  resetPanelsVal({ commit }) {
    commit('setPanelsVal', {
      panelsVal: initialState().panelsVal,
    });
  },

  updateOffer({ state, commit }) {
    const {
      roofType,
      solarPanelType,
      roof,
      coordinates,
      CustomerType,
      offers,
    } = state;

    if (
      roofType &&
      solarPanelType &&
      offers['roofTypeId_' + roofType.id] &&
      offers['roofTypeId_' + roofType.id]['panelTypeId_' + solarPanelType.id]
    ) {
      commit('setOffer', {
        offer:
          offers['roofTypeId_' + roofType.id][
            'panelTypeId_' + solarPanelType.id
          ],
      });
      return;
    }
    commit('setIsLoading', true);
    http
      .post('solkart-offer', {
        roof: roof,
        roofType: roofType,
        solarPanelType: solarPanelType,
        coordinates: coordinates,
        customerType: CustomerType.value,
      })
      .then(function (r) {
        // Don't update offer if the roof and panel in state is different when submitting the offer request
        if (
          roofType.id === state.roofType.id &&
          solarPanelType.id === state.solarPanelType.id
        ) {
          commit('setOffer', {
            offer: r.data,
          });

          if (offers['roofTypeId_' + roofType.id]) {
            const updatedOffers = {
              ...offers,
              ['roofTypeId_' + roofType.id]: {
                ...offers['roofTypeId_' + roofType.id],
                ['panelTypeId_' + solarPanelType.id]: r.data,
              },
            };

            commit('setOffers', updatedOffers);
          } else {
            const updatedOffers = {
              ...offers,
              ['roofTypeId_' + roofType.id]: {
                ['panelTypeId_' + solarPanelType.id]: r.data,
              },
            };

            commit('setOffers', updatedOffers);
          }
        }

        commit('setSelectedAddress', r.data.adresse);
        commit('setIsLoading', false);
      })
      .catch(function (error) {
        // eslint-disable-next-line
        console.error('error saving new offer data', error);
      });
  },
};

const getters = {
  isNextButtonDisabled: (state) => {
    return (
      !state.roof ||
      (state.currentPageIndex === 4 && !state.CustomerInformationValid) ||
      (state.currentPageIndex === 5 &&
        !state.CustomerInformation.agreedToTerms) ||
      state.isOfferSubmitted ||
      (state.currentPageIndex === 3 && !state.panelsVal.pris)
    );
  },
  nextButtonText: (state) => {
    if (state.isOfferSubmitted) {
      return 'Innsendt';
    }

    if (state.currentPageIndex === 5) {
      return 'Send inn';
    }

    return 'Neste';
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
